import { LinearProgress, Menu, MenuItem } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React, { useState } from "react";
import moment from "moment";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authentication/authConfig";
import { Typography } from "@mui/material";
import axios from "axios";
import "react-big-calendar/lib/css/react-big-calendar.css";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { RRule } from "rrule";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { useSharedFormState } from "../shared/sharedState";
import { acquireToken } from "../authentication/utils/authUtils";
import { isDateOnHoliday, getFilteredHolidays } from "../utils/datetimeutils";
export function Toolbar(props) {
  const {
    eventsData,
    setEventsData,
    teamsData,
    coachesData,
    modifiedEvents,
    setModifiedEvents,
    deletedEvents,
    setDeletedEvents,
    schedulerAccount,
    setSchedulerAccount,
  } = useSharedFormState();

  const filteredHolidays = getFilteredHolidays();
  const [viewState, setViewState] = useState("week");
  const [alignment, setAlignment] = useState("week");
  const [sendChangesDialogOpen, setSendChangesDialogOpen] = useState(false);

  const [teamId, setTeamId] = useState("");
  const [team, setTeam] = useState("");

  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState(0);
  const [startTime, setStartTime] = React.useState(new Date());
  const [endTime, setEndTime] = React.useState(new Date());
  const [initDate, setInitDate] = useState(new Date());
  const [coach, setCoach] = useState(new Map());
  const [coachEmail, setCoachEmail] = useState("");
  const [batchingSuccessfulResults, setBatchingSuccessfulResults] = useState(
    []
  );
  const [batchingFailureResults, setBatchingFailureResults] = useState([]);
  const [onlineChecked, setOnlineChecked] = useState(false);

  const [loadingSubmission, setLoadingSubmission] = useState(false);
  const [submissionFinished, setSubmissionFinished] = useState(false);

  const [sendChangesButtonDisabled, setSendChangesButtonDisabled] =
    useState(false);

  const [weekChecked, setWeekChecked] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [creationDialogOpen, setCreationDialogOpen] = useState(false);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  let activeAccount = instance ? instance.getActiveAccount() : null;

  const handleLoginRedirect = () => {
    document.body.style.overflow = "hidden";
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    document.body.style.overflow = "auto";
    instance.logoutRedirect({
      account: instance.getActiveAccount(),
    });
  };

  const style = {
    marginTop: "5px",
    marginBottom: "5px",
    marginRight: "1px",
    marginLeft: "1px",
  };
  const styleCenter = {
    marginRight: "10px",
    marginLeft: "10px",
  };

  const styleBot = {
    marginBottom: "20px",
  };

  async function getTeamMembers(id) {
    return teamsData.get(id).members;
  }

  function formatDateString(date) {
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      date.getDate().toString().padStart(2, "0") +
      "T" +
      date.getHours().toString().padStart(2, "0") +
      ":" +
      date.getMinutes().toString().padStart(2, "0") +
      ":" +
      date.getSeconds().toString().padStart(2, "0")
    );
  }

  function formatTimeZone(date) {
    let timezone = date
      .toString()
      .slice(34)
      .replace(/([()])/g, "");

    //even if the date is dst microsoft graph api wants the text to say standard
    return (timezone = timezone.includes("Daylight")
      ? timezone.replace("Daylight", "Standard")
      : timezone);
  }

  function createNewMicrosoftTeamsEventObject(
    event,
    datestartstring,
    dateendstring,
    timezone,
    transactionId,
    participants
  ) {
    let baseObj = baseMicrosoftTeamsEventObjectTemplate(
      event,
      datestartstring,
      dateendstring,
      timezone,
      participants
    );
    baseObj.categories = event.online ? ["Green category"] : ["Blue category"];
    baseObj.transactionId = transactionId;
    return baseObj;
  }

  function baseMicrosoftTeamsEventObjectTemplate(
    event,
    datestartstring,
    dateendstring,
    timezone,
    participants
  ) {
    return {
      subject: event.title,
      start: {
        dateTime: datestartstring,
        timeZone: timezone,
      },
      end: {
        dateTime: dateendstring,
        timeZone: timezone,
      },

      allowNewTimeProposals: true,
      isOnlineMeeting: event.online,
      attendees: participants,
    };
  }

  function handleBatchingResults(i, response, action) {
    let batchingResults = response.data.res.responses;
    for (let j = 0; j < batchingResults.length; j++) {
      let meetingNumber = 20 * i + j;
      if (batchingResults[j].status >= 400) {
        setBatchingFailureResults((prevArray) => [
          ...prevArray,
          "Failed to " +
            action +
            " MS Teams meeting " +
            (meetingNumber + 1) +
            " with message: " +
            batchingResults[j].body.error.message,
        ]);
      } else {
        setBatchingSuccessfulResults((prevArray) => [
          ...prevArray,
          "Successful " +
            action +
            " of Microsoft Teams meeting " +
            (meetingNumber + 1),
        ]);
      }
    }
  }

  async function pushFreshEvents() {
    //batch size limit from microsoft is 20. Mailbox concurrent connection limit is 4 but ms will handle the concurrency in your batch for you.
    //we just cant run multiple batches in parallel or else will get a concurrency limit error.
    let batchedObjArray = [];
    let batchedObj = {
      requests: [],
    };
    for (const event of modifiedEvents.values()) {
      let datestartstring = formatDateString(event.start);
      let dateendstring = formatDateString(event.end);
      let timezone = formatTimeZone(event.start);
      let studentsData = await getTeamMembers(event.teamId);
      let participants = [];
      event.coach.forEach((value, key) => {
        let coachobject = {
          emailAddress: {
            address: key,
            name: value,
          },
          type: "required",
        };
        participants.push(coachobject);
      });
      for (let i = 0; i < studentsData.length; i++) {
        let studentobj = {
          emailAddress: {
            address: studentsData[i].mail,
            name: studentsData[i].displayName,
          },
          type: "required",
        };
        participants.push(studentobj);
      }
      event.additionalParticipants.forEach((key, value) => {
        let participantobj = {
          emailAddress: {
            address: key,
            name: value,
          },
          type: "required",
        };
        participants.push(participantobj);
      });
      if (event.isFresh) {
        let transactionId = event.id + "_" + event.teamId;
        let dataobj = createNewMicrosoftTeamsEventObject(
          event,
          datestartstring,
          dateendstring,
          timezone,
          transactionId,
          participants
        );
        batchedObj.requests.push({
          id: crypto.randomUUID(),
          method: "POST",
          url: `/users/${schedulerAccount}/events`,
          body: dataobj,
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (batchedObj.requests.length == 20) {
          batchedObjArray.push({ ...batchedObj });
          batchedObj = {
            requests: [],
          };
        }
      } else if (deletedEvents.indexOf(event.iCalUId) == -1) {
        let dataobj = baseMicrosoftTeamsEventObjectTemplate(
          event,
          datestartstring,
          dateendstring,
          timezone,
          participants
        );
        batchedObj.requests.push({
          id: crypto.randomUUID(),
          method: "PATCH",
          url: `/users/${schedulerAccount}/events/` + event.rawId,
          body: dataobj,
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (batchedObj.requests.length == 20) {
          batchedObjArray.push({ ...batchedObj });
          batchedObj = {
            requests: [],
          };
        }
      }
    }
    if (batchedObj.requests.length != 0) {
      batchedObjArray.push(batchedObj);
    }
    let token = await acquireToken(instance, account);
    for (let i = 0; i < batchedObjArray.length; i++) {
      let response = await axios.post("/api/createBatch", batchedObjArray[i], {
        headers: { Authorization: token.accessToken },
      });
      handleBatchingResults(i, response, "Create/Modify");
    }
    setModifiedEvents(new Map());
    await deleteSchedulerEvents();
    setSubmissionFinished(true);
  }

  async function deleteSchedulerEvents() {
    let batchedSchedulerDeletionObjArray = [];
    let batchedSchedulerDeletionObj = {
      requests: [],
    };
    for (let i = 0; i < deletedEvents.length; i++) {
      if (deletedEvents[i].rawId != null) {
        batchedSchedulerDeletionObj.requests.push({
          id: i,
          method: "DELETE",
          url:
            "/users/" +
            deletedEvents[i].organizer.emailAddress.address +
            "/events/" +
            deletedEvents[i].rawId,
        });
        if (batchedSchedulerDeletionObj.requests.length == 20) {
          batchedSchedulerDeletionObjArray.push({
            ...batchedSchedulerDeletionObj,
          });
          batchedSchedulerDeletionObj = {
            requests: [],
          };
        }
      }
    }

    if (batchedSchedulerDeletionObj.requests.length != 0) {
      batchedSchedulerDeletionObjArray.push(batchedSchedulerDeletionObj);
    }

    let token = await acquireToken(instance, account);
    for (let i = 0; i < batchedSchedulerDeletionObjArray.length; i++) {
      let response = await axios.post(
        "/api/createBatch",
        batchedSchedulerDeletionObjArray[i],
        {
          headers: { Authorization: token.accessToken },
        }
      );
      handleBatchingResults(i, response, "Delete");
    }

    setDeletedEvents([]);
  }

  const handleClockChange = (newValue) => {
    setStartTime(newValue);
  };

  const handleEndClockChange = (newValue) => {
    setEndTime(newValue);
  };

  const handleSendChangesDialogOpen = () => {
    setSubmissionFinished(false);
    setSendChangesDialogOpen(true);
  };

  const handleSendChangesDialogClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setSendChangesButtonDisabled(false);
    setLoadingSubmission(false);
    // setSendChangesDialogOpen(false);
  };

  async function handleSendChangesDialogSubmit() {
    setLoadingSubmission(true);
    await pushFreshEvents();
    handleSendChangesDialogClose();
  }

  const handleCreationDialogOpen = () => {
    setCreationDialogOpen(true);
  };

  const handleCreationDialogClose = () => {
    setCreationDialogOpen(false);
  };

  const handleCreationDialogSubmit = () => {
    setCreationDialogOpen(false);
    var checkedDayNames = [];
    for (var i = 0; i < weekChecked.length; i++) {
      if (weekChecked[i]) {
        switch (i) {
          case 0:
            checkedDayNames.push("Monday");
            break;
          case 1:
            checkedDayNames.push("Tuesday");
            break;
          case 2:
            checkedDayNames.push("Wednesday");
            break;
          case 3:
            checkedDayNames.push("Thursday");
            break;
          case 4:
            checkedDayNames.push("Friday");
            break;
          case 5:
            checkedDayNames.push("Saturday");
            break;
          case 6:
            checkedDayNames.push("Sunday");
            break;
        }
      }
    }

    let allDates = [];
    let skippedHolidays = [];

    checkedDayNames.sort(
      (a, b) => moment().day(a).day() - moment().day(b).day()
    );

    checkedDayNames.forEach((day) => {
      let start = moment(initDate)
        .day(day)
        .set({
          hour: moment(startTime, "HH:mm").hour(),
          minute: moment(startTime, "HH:mm").minute(),
        })
        .tz("America/Toronto");

      if (start.isBefore(initDate)) {
        start.add(7, "days");
      }

      start = start.toDate();

      let end = moment(initDate)
        .day(day)
        .set({
          hour: moment(endTime, "HH:mm").hour(),
          minute: moment(endTime, "HH:mm").minute(),
        })
        .tz("America/Toronto");

      if (end.isBefore(initDate)) {
        end.add(7, "days");
      }
      end = end.toDate();


      const rule = new RRule({
        freq: RRule.WEEKLY,
        dtstart: start,
        count: Math.ceil(amount / checkedDayNames.length),
      });
      const occurrences = rule.all().map(date => {
      return moment.utc(date).tz("America/Toronto").toDate();
      });

      occurrences.forEach((occurrence) => {
        let startTime = new Date(occurrence);
        startTime.setHours(start.getHours(), start.getMinutes());
        let endTime = new Date(startTime);
        endTime.setHours(end.getHours(), end.getMinutes());

        if (isDateOnHoliday(startTime, filteredHolidays)) {
          skippedHolidays.push({ start: startTime, end: endTime });
        } else {
          allDates.push({ start: startTime, end: endTime });
        }
      });
    });
    allDates.sort((a, b) => a.start - b.start);
    allDates = allDates.slice(0, amount);
    if (skippedHolidays.length > 0) {
      let lastClassDate = moment(allDates[allDates.length - 1].start);
      skippedHolidays.forEach(({ start, end }) => {
        let rescheduledDate = moment(lastClassDate);
        while (true) {
          rescheduledDate.add(1, "days");
          let dayName = rescheduledDate.format("dddd");
          if (checkedDayNames.includes(dayName)) break;
        }
        let newStart = rescheduledDate.toDate();
        let newEnd = moment(newStart)
          .set({ hour: end.getHours(), minute: end.getMinutes() })
          .toDate();
        allDates.push({ start: newStart, end: newEnd });
        lastClassDate = rescheduledDate;
      });
    }
    allDates.sort((a, b) => a.start - b.start);
    let copiedEventsData = new Map(eventsData);
    let copiedModifiedEvents = new Map(modifiedEvents);
    let id = crypto.randomUUID();
    for (let i = 0; i < amount; i++) {
      var start = allDates[i].start;
      var end = allDates[i].end;
      let seriesid = id + "_series_" + crypto.randomUUID();
      var online = onlineChecked;
      let additionalParticipants = new Map();
      let isRecurring = true;
      let isFresh = true;
      var category = online ? "Green category" : "Blue category";
      let newEvent = {
        start,
        end,
        title,
        id: seriesid,
        coach,
        coachEmail,
        team,
        teamId,
        isRecurring,
        online,
        category,
        isFresh,
        additionalParticipants,
      };
      copiedModifiedEvents.set(seriesid, newEvent);
      copiedEventsData.set(seriesid, newEvent);
    }
    setModifiedEvents(copiedModifiedEvents);
    setEventsData(copiedEventsData);
  };

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  const goToDayView = () => {
    props.onView("day");
    setViewState("day");
  };
  const goToWeekView = () => {
    props.onView("week");
    setViewState("week");
  };
  const goToMonthView = () => {
    props.onView("month");
    setViewState("month");
  };
  const goToBack = () => {
    let view = viewState;
    let mDate = props.date;
    let newDate;
    if (view === "month") {
      newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
    } else if (view === "week") {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() - 7,
        1
      );
    } else {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() - 1,
        1
      );
    }
    props.onNavigate("prev", newDate);
  };
  const goToNext = () => {
    let view = viewState;
    let mDate = props.date;
    let newDate;
    if (view === "month") {
      newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1);
    } else if (view === "week") {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() + 7,
        1
      );
    } else {
      newDate = new Date(
        mDate.getFullYear(),
        mDate.getMonth(),
        mDate.getDate() + 1,
        1
      );
    }
    props.onNavigate("next", newDate);
  };

  const goToToday = () => {
    const now = new Date();
    props.date.setMonth(now.getMonth());
    props.date.setYear(now.getFullYear());
    props.date.setDate(now.getDate());
    props.onNavigate("current");
  };

  const month = () => {
    const date = moment(props.date);
    let month = date.format("MMMM");
    let day = date.format("D");

    return (
      <span className="rbc-toolbar-label rbc-date">
        <i className="far fa-calendar"></i>{" "}
        <span style={styleCenter}>{`${month} ${day}  `}</span>
      </span>
    );
  };

  const handleOnlineCheckedChange = () => {
    setOnlineChecked(!onlineChecked);
  };

  const handleWeekChecked = (index) => {
    setWeekChecked(weekChecked.map((v, i) => (i === index ? !v : v)));
  };

  const handleInitDateChange = (date) => {
    setInitDate(date);
  };

  let overlappedEvents = Array.from(eventsData.values()).map((event) => {
    if (event.overlaps) {
      return <div>Overlap at: {event.start.toDateString()}</div>;
    }
  });

  return (
    <div>
      <div className="rbc-toolbar-item-3">
        <Button
          style={style}
          variant="outlined"
          className="next-icon today"
          onClick={handleSendChangesDialogOpen}
        >
          Submit Changes
        </Button>

        <Button
          style={style}
          variant="outlined"
          className="next-icon today"
          onClick={handleCreationDialogOpen}
        >
          Create a Series of Classes
        </Button>
        <Button
          startIcon={<WbSunnyIcon />}
          color="primary"
          style={style}
          variant="contained"
          className="next-icon today"
          onClick={goToToday}
        >
          Today
        </Button>
        <Button
          color="secondary"
          style={style}
          variant="contained"
          className="prev-icon"
          id="prev-btn-icon"
          onClick={goToBack}
        >
          &#8249;
        </Button>
        <Button
          color="secondary"
          style={style}
          variant="contained"
          className="next-icon"
          id="next-btn-icon"
          onClick={goToNext}
        >
          &#8250;
        </Button>
        {month()}
        <span className="rbc-btn-group">
          <ToggleButtonGroup
            color="primary"
            value={alignment}
            exclusive
            onChange={handleChange}
          >
            <ToggleButton value="month" onClick={goToMonthView}>
              Month
            </ToggleButton>
            <ToggleButton value="day" onClick={goToDayView}>
              Day
            </ToggleButton>
            <ToggleButton value="week" onClick={goToWeekView}>
              Week
            </ToggleButton>
          </ToggleButtonGroup>
        </span>
        <Dialog
          open={sendChangesDialogOpen}
          onClose={handleSendChangesDialogClose}
        >
          <DialogTitle>Review</DialogTitle>
          <DialogContent>
            {loadingSubmission ? (
              <>
                <LinearProgress />{" "}
                {batchingFailureResults.map((result, index) => (
                  <Typography key={index} variant="body2" color="error">
                    {result}
                  </Typography>
                ))}
                {batchingSuccessfulResults.map((result, index) => (
                  <Typography key={index} variant="body2">
                    {result}
                  </Typography>
                ))}
              </>
            ) : (
              <>
                {overlappedEvents}
                {batchingFailureResults.map((result, index) => (
                  <Typography key={index} variant="body2" color="error">
                    {result}
                  </Typography>
                ))}
                {batchingSuccessfulResults.map((result, index) => (
                  <Typography key={index} variant="body2">
                    {result}
                  </Typography>
                ))}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => window.location.reload()}
              disabled={sendChangesButtonDisabled}
            >
              Close
            </Button>
            {!submissionFinished && (
              <Button
                onClick={() => {
                  setSendChangesButtonDisabled(true);
                  handleSendChangesDialogSubmit();
                }}
                disabled={sendChangesButtonDisabled}
              >
                Submit
              </Button>
            )}
          </DialogActions>
        </Dialog>
        <Dialog
          maxWidth="lg"
          open={creationDialogOpen}
          onClose={handleCreationDialogClose}
        >
          <DialogTitle>Create a series of meetings</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              onChange={(e) => setTitle(e.target.value)}
              margin="dense"
              label="Meeting Title"
            />

            <Autocomplete
              multiple
              fullWidth
              id="combo-box-demo"
              options={Array.from(coachesData.values())}
              getOptionLabel={(option) => option.displayName || ""}
              renderOption={(props, option) => {
                return (
                  <div>
                    <Tooltip placement="left" title={option.mail}>
                      <Button
                        sx={{ textTransform: "none" }}
                        component="li"
                        {...props}
                        fullWidth
                      >
                        {props.key}
                      </Button>
                    </Tooltip>
                  </div>
                );
              }}
              onChange={(e, v) => {
                let coachMap = new Map();
                v.forEach((c) => {
                  coachMap.set(c.mail, c.displayName);
                });
                setCoach(coachMap);
              }}
              renderInput={(params) => (
                <TextField margin="dense" {...params} label="Coach" />
              )}
            />
            <Autocomplete
              id="combo-box-demo1"
              fullWidth
              options={Array.from(teamsData.values())}
              getOptionLabel={(option) => option.displayName || ""}
              onChange={(e, v) => {
                setTeam(v.displayName);
                setTeamId(v.id);
              }}
              renderInput={(params) => (
                <TextField fullWidth margin="dense" {...params} label="Team" />
              )}
            />

            <TextField
              style={styleBot}
              fullWidth
              InputProps={{ inputProps: { min: 1 } }}
              type="number"
              onChange={(e) => setAmount(Number(e.target.value))}
              margin="dense"
              label="Amount of classes"
            />

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Starting from"
                inputFormat="MM/DD/yyyy"
                value={initDate}
                onChange={handleInitDateChange}
                renderInput={(params) => <TextField {...params} />}
              />

              <TimePicker
                minutesStep={5}
                label="Start Time"
                value={startTime}
                onChange={handleClockChange}
                renderInput={(params) => <TextField {...params} />}
              />
              <TimePicker
                label="End Time"
                minutesStep={5}
                value={endTime}
                onChange={handleEndClockChange}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <Box whiteSpace="nowrap" component="div" display="block">
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[0]}
                    onClick={() => handleWeekChecked(0)}
                  />
                }
                label="Monday"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[1]}
                    onClick={() => handleWeekChecked(1)}
                  />
                }
                label="Tuesday"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[2]}
                    onClick={() => handleWeekChecked(2)}
                  />
                }
                label="Wednesday"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[3]}
                    onClick={() => handleWeekChecked(3)}
                  />
                }
                label="Thursday"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[4]}
                    onClick={() => handleWeekChecked(4)}
                  />
                }
                label="Friday"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[5]}
                    onClick={() => handleWeekChecked(5)}
                  />
                }
                label="Saturday"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    color="primary"
                    checked={weekChecked[6]}
                    onClick={() => handleWeekChecked(6)}
                  />
                }
                label="Sunday"
                labelPlacement="end"
              />
            </Box>
            <FormControlLabel
              value="start"
              control={
                <Checkbox
                  checked={onlineChecked}
                  onChange={handleOnlineCheckedChange}
                />
              }
              label="Online"
              labelPlacement="end"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCreationDialogClose}>Cancel</Button>
            <Button onClick={handleCreationDialogSubmit}>Submit</Button>
          </DialogActions>
        </Dialog>
        {activeAccount ? (
          <>
            <Button
              variant="contained"
              color="warning"
              onClick={handleMenuOpen}
            >
              {activeAccount.name || "Unknown"}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleLogoutRedirect}>Sign out</MenuItem>
            </Menu>
          </>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={handleLoginRedirect}
          >
            Sign in
          </Button>
        )}
      </div>
    </div>
  );
}
